<template>
  <div class="wheel-battle-basic-info">
    <van-cell-group :border="false" class="form-cells">
      <van-cell
        title="阶段"
        :value="stageDisplay || '请选择'"
        :value-class="stageDisplay ? '' : 'placeholder-value'"
        :is-link="editable"
        :clickable="editable"
        @click="onStageClick"
      />
      <van-cell
        title="日期"
        :value="dateDisplay || '请选择'"
        :value-class="dateDisplay ? '' : 'placeholder-value'"
        :is-link="editable"
        :clickable="editable"
        @click="onDateClick"
      />
      <van-cell
        title="时间"
        :value="timeOnlyDisplay || '请选择'"
        :value-class="timeOnlyDisplay ? '' : 'placeholder-value'"
        :is-link="editable"
        :clickable="editable"
        @click="onTimeClick"
      />
      <van-field
        v-if="editable"
        :value="form.stadiumName"
        label="球场"
        placeholder="请输入球场"
        input-align="right"
        :border="false"
        class="stadium-field"
        @input="onStadiumNameInput"
      />
      <van-cell
        v-else
        title="球场"
        :value="form.stadiumName || '-'"
      />
      <van-cell
        title="场地"
        :value="form.pitchName || '请选择'"
        :value-class="form.pitchName ? '' : 'placeholder-value'"
        :is-link="editable"
        :clickable="editable"
        @click="onPitchClick"
      />
    </van-cell-group>

    <van-cell-group v-if="showGroup" :border="false" class="form-cells group-cells">
      <van-cell
        title="小组"
        :value="form.groupName || '请选择'"
        :value-class="form.groupName ? '' : 'placeholder-value'"
        :is-link="editable"
        :clickable="editable"
        @click="onGroupClick"
      />
    </van-cell-group>

    <div class="rules-section">
      <div class="rules-title">车轮战规则</div>
      <div class="rules-body">
        <div class="rules-line">轮转种类：{{ displayRules.rotationType || '-' }}</div>
        <div class="rules-line">时长：{{ durationText }}</div>
        <div class="rules-line">获胜条件：{{ displayRules.winCondition || '-' }}</div>
        <div class="rules-line">下场规则：{{ displayRules.offRuleText || '-' }}</div>
      </div>
    </div>

    <van-popup v-model="showStagePicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="选择阶段"
        value-key="label"
        :columns="stageList"
        @confirm="onStageConfirm"
        @cancel="showStagePicker = false"
      />
    </van-popup>

    <van-popup v-model="showDatePicker" position="bottom" round>
      <van-datetime-picker
        type="date"
        :value="datePickerValue"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom" round>
      <van-datetime-picker
        type="time"
        :value="timePickerValue"
        :filter="filterMinute"
        @confirm="onTimeConfirm"
        @cancel="showTimePicker = false"
      />
    </van-popup>

    <van-popup v-model="showFieldPicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="选择场地"
        value-key="name"
        :columns="fieldList"
        @confirm="onFieldConfirm"
        @cancel="showFieldPicker = false"
      />
    </van-popup>

    <van-popup v-model="showGroupPicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="选择小组"
        value-key="name"
        :columns="groupList"
        @confirm="onGroupConfirm"
        @cancel="showGroupPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, Field, Popup, DatetimePicker, Picker, Toast } from 'vant'
Vue.use(Cell).use(CellGroup).use(Field).use(Popup).use(DatetimePicker).use(Picker).use(Toast)

import { formatWheelBattleDateOnly, formatWheelBattleTimeOnly } from '../utils/format'
import { adminGetUnionMatchFieldsGames } from '@/api/match-team-game'
import { adminGetBMMatchStageGroupList } from '@/api/wheel-battle'
import { adminGetMatchStageList } from '@/api/match'
import { stageRuleToDisplayRules } from '@/api/wheel-battle/adapter'

function formatGroupDisplayName(name) {
  if (!name) {
    return ''
  }
  if (String(name).indexOf('组') !== -1) {
    return String(name)
  }
  return String(name) + '组'
}

export default {
  name: 'WheelBattleBasicInfoForm',
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    rules: {
      type: Object,
      default: function () {
        return {}
      }
    },
    showGroup: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    unionMatchId: {
      type: String,
      default: ''
    },
    matchId: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      showStagePicker: false,
      showDatePicker: false,
      showTimePicker: false,
      showFieldPicker: false,
      showGroupPicker: false,
      datePickerValue: new Date(),
      timePickerValue: '12:00',
      fieldList: [],
      fieldListLoaded: false,
      stageList: [],
      allStageList: [],
      stageRawList: [],
      stageListLoaded: false,
      groupList: [],
      groupListLoaded: false
    }
  },
  computed: {
    form: function () {
      return this.value || {}
    },
    dateDisplay: function () {
      return formatWheelBattleDateOnly(this.form.beginDate)
    },
    timeOnlyDisplay: function () {
      return formatWheelBattleTimeOnly(this.form.beginDate)
    },
    displayRules: function () {
      var propRules = this.rules || {}
      if (this.hasDisplayRules(propRules)) {
        return propRules
      }
      return this.resolveRulesFromStageId(this.selectedStageId)
    },
    durationText: function () {
      var rules = this.displayRules || {}
      var minutes = rules.duration != null ? rules.duration : rules.durationMinutes
      if (minutes === undefined || minutes === null || minutes === '') {
        return '-'
      }
      return minutes + '分钟'
    },
    selectedStageId: function () {
      return this.form.roundId ? String(this.form.roundId) : ''
    },
    stageDisplay: function () {
      if (this.form.roundLabel) {
        return this.form.roundLabel
      }
      return this.resolveStageLabel(this.form.roundId)
    }
  },
  watch: {
    unionMatchId: function () {
      this.loadFieldList()
    },
    matchId: function () {
      this.loadStageList()
      this.loadGroupList()
    },
    selectedStageId: function () {
      this.loadGroupList()
      this.syncStageLabelToForm()
    },
    stageList: function () {
      this.syncStageLabelToForm()
    }
  },
  mounted: function () {
    if (this.unionMatchId) {
      this.loadFieldList()
    }
    if (this.matchId) {
      this.loadStageList()
    }
    if (this.matchId && this.selectedStageId) {
      this.loadGroupList()
    }
  },
  methods: {
    filterMinute: function (type, options) {
      if (type === 'minute') {
        return options.filter(function (option) {
          return option % 5 === 0
        })
      }
      return options
    },
    emitForm: function (patch) {
      var next = Object.assign({}, this.form, patch)
      this.$emit('input', next)
      this.$emit('change', next)
    },
    hasDisplayRules: function (rules) {
      if (!rules) {
        return false
      }
      return !!(
        rules.rotationType ||
        rules.winCondition ||
        rules.offRuleText ||
        rules.duration != null ||
        rules.durationMinutes != null
      )
    },
    resolveRulesFromStageId: function (stageId) {
      if (!stageId) {
        return {}
      }
      var id = String(stageId)
      var list = this.stageRawList || []
      for (var i = 0; i < list.length; i++) {
        var item = list[i]
        if (String(item.id) === id) {
          return stageRuleToDisplayRules(item.stageRule || item)
        }
      }
      return {}
    },
    resolveStageLabel: function (stageId) {
      if (!stageId) {
        return ''
      }
      var id = String(stageId)
      var lists = [this.stageList, this.allStageList]
      for (var l = 0; l < lists.length; l++) {
        var list = lists[l] || []
        for (var i = 0; i < list.length; i++) {
          if (String(list[i].id) === id) {
            return list[i].label || list[i].stageName || list[i].name || ''
          }
        }
      }
      return ''
    },
    syncStageLabelToForm: function () {
      if (this.form.roundLabel || !this.form.roundId) {
        return
      }
      var label = this.resolveStageLabel(this.form.roundId)
      if (label) {
        this.emitForm({ roundLabel: label })
      }
    },
    loadFieldList: function () {
      var self = this
      if (!this.unionMatchId) {
        return
      }
      adminGetUnionMatchFieldsGames({ unionMatchId: this.unionMatchId }).then(function (res) {
        self.fieldListLoaded = true
        if (!res || !res.data) {
          self.fieldList = []
          return
        }
        self.fieldList = res.data.list || []
      }).catch(function () {
        self.fieldListLoaded = true
        self.fieldList = []
      })
    },
    loadStageList: function () {
      var self = this
      if (!this.matchId) {
        this.stageList = []
        this.allStageList = []
        this.stageRawList = []
        this.stageListLoaded = false
        return
      }
      this.stageListLoaded = false
      adminGetMatchStageList({
        matchId: this.matchId
      }).then(function (res) {
        self.stageListLoaded = true
        if (!res || !res.data) {
          self.stageList = []
          self.allStageList = []
          self.stageRawList = []
          return
        }
        var rawList = res.data.list || []
        self.stageRawList = rawList
        self.allStageList = rawList.map(function (item) {
          return {
            id: String(item.id),
            label: item.stageName || item.name || ''
          }
        })
        self.stageList = rawList.filter(function (item) {
          return item.ruleType === '车轮战'
        }).map(function (item) {
          return {
            id: String(item.id),
            label: item.stageName || item.name || ''
          }
        })
        self.syncStageLabelToForm()
      }).catch(function () {
        self.stageListLoaded = true
        self.stageList = []
        self.allStageList = []
        self.stageRawList = []
      })
    },
    loadGroupList: function () {
      var self = this
      if (!this.matchId || !this.selectedStageId) {
        this.groupList = []
        this.groupListLoaded = false
        return
      }
      this.groupListLoaded = false
      adminGetBMMatchStageGroupList({
        matchId: this.matchId,
        stageId: this.selectedStageId
      }).then(function (res) {
        self.groupListLoaded = true
        if (!res || !res.data) {
          self.groupList = []
          return
        }
        self.groupList = (res.data.list || []).map(function (item) {
          return {
            id: String(item.id),
            name: formatGroupDisplayName(item.name),
            teams: item.teams || []
          }
        })
      }).catch(function () {
        self.groupListLoaded = true
        self.groupList = []
      })
    },
    onStadiumNameInput: function (value) {
      this.emitForm({ stadiumName: value })
    },
    onStageClick: function () {
      if (!this.editable) {
        return
      }
      if (!this.matchId) {
        Toast('缺少赛事信息')
        return
      }
      if (!this.stageListLoaded) {
        Toast('阶段加载中，请稍后')
        return
      }
      if (!this.stageList.length) {
        Toast('暂无车轮战阶段')
        return
      }
      this.showStagePicker = true
    },
    onStageConfirm: function (stage) {
      this.showStagePicker = false
      if (!stage) {
        return
      }
      var prevStageId = this.form.roundId
      var patch = {
        roundId: stage.id,
        roundLabel: stage.label
      }
      if (prevStageId !== stage.id) {
        patch.groupId = ''
        patch.groupName = ''
        patch.groupTeams = []
      }
      this.emitForm(patch)
    },
    onDateClick: function () {
      if (!this.editable) {
        return
      }
      this.datePickerValue = this.form.beginDate ? new Date(this.form.beginDate) : new Date()
      this.showDatePicker = true
    },
    onTimeClick: function () {
      if (!this.editable) {
        return
      }
      this.timePickerValue = this.resolveTimePickerValue(this.form.beginDate)
      this.showTimePicker = true
    },
    resolveTimePickerValue: function (dateVal) {
      if (!dateVal) {
        return '12:00'
      }
      var timeText = formatWheelBattleTimeOnly(dateVal)
      return timeText || '12:00'
    },
    mergeBeginDateParts: function (datePart, timeText) {
      var base = datePart ? new Date(datePart) : new Date()
      if (isNaN(base.getTime())) {
        base = new Date()
      }
      var parts = String(timeText || '12:00').split(':')
      var hours = parseInt(parts[0], 10)
      var minutes = parseInt(parts[1], 10)
      if (isNaN(hours)) {
        hours = 12
      }
      if (isNaN(minutes)) {
        minutes = 0
      }
      base.setHours(hours, minutes, 0, 0)
      return base
    },
    onDateConfirm: function (value) {
      this.showDatePicker = false
      var timeText = this.form.beginDate
        ? formatWheelBattleTimeOnly(this.form.beginDate)
        : '12:00'
      this.emitForm({ beginDate: this.mergeBeginDateParts(value, timeText) })
    },
    onTimeConfirm: function (value) {
      this.showTimePicker = false
      var datePart = this.form.beginDate ? new Date(this.form.beginDate) : new Date()
      this.emitForm({ beginDate: this.mergeBeginDateParts(datePart, value) })
    },
    onPitchClick: function () {
      if (!this.editable) {
        return
      }
      if (!this.unionMatchId) {
        Toast('缺少赛事信息')
        return
      }
      if (!this.fieldListLoaded) {
        Toast('场地加载中，请稍后')
        return
      }
      if (!this.fieldList.length) {
        Toast('暂无场地数据')
        return
      }
      this.showFieldPicker = true
    },
    onFieldConfirm: function (field) {
      this.showFieldPicker = false
      if (!field) {
        return
      }
      this.emitForm({
        pitchId: String(field.id),
        pitchName: field.name
      })
    },
    onGroupClick: function () {
      if (!this.editable) {
        return
      }
      if (!this.matchId) {
        Toast('缺少赛事信息')
        return
      }
      if (!this.selectedStageId) {
        Toast('请先选择阶段')
        return
      }
      if (!this.groupListLoaded) {
        Toast('小组加载中，请稍后')
        return
      }
      if (!this.groupList.length) {
        Toast('暂无小组数据')
        return
      }
      this.showGroupPicker = true
    },
    onGroupConfirm: function (group) {
      this.showGroupPicker = false
      if (!group) {
        return
      }
      this.emitForm({
        groupId: group.id,
        groupName: group.name,
        groupTeams: group.teams || []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-basic-info {
  background: transparent;
}

.form-cells {
  background: #fff;

  ::v-deep .van-cell {
    padding: 14px 16px;
    font-size: 14px;
    color: #333;

    &::after {
      left: 16px;
      right: 16px;
    }
  }

  ::v-deep .van-cell__title {
    flex: none;
    width: 56px;
    color: #999999;
  }

  ::v-deep .van-cell__value {
    color: #333;
    text-align: right;
  }

  ::v-deep .placeholder-value {
    color: #c8c8c8;
  }
}

.stadium-field {
  padding: 14px 16px;

  ::v-deep .van-field__label {
    flex: none;
    width: 56px;
    margin-right: 0;
    color: #999999;
  }

  ::v-deep .van-field__control {
    color: #333;
  }

  ::v-deep .van-field__control::placeholder {
    color: #c8c8c8;
  }
}

.group-cells {
  margin-top: 10px;
}

.rules-section {
  margin-top: 12px;
  padding: 16px;
  background: transparent;
}

.rules-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.rules-body {
  font-size: 13px;
  color: #999999;
  line-height: 1.8;
}

.rules-line + .rules-line {
  margin-top: 2px;
}
</style>
